import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CohortCard } from "./CohortCard";
import { selectLogInUsername } from "../../../common/authenticateDashboard/authSlice";
import { cartImage, visitorImage, dollarImage } from "../../../assets/index";
import { graphUniqueBnDev, SelectUniqueBrowsers } from "../../Main/components/UniqueBnDev/uniqueBnDevSlice";
import { SelectBookingsVisitors, graphUniqueBookings } from "../../Main/components/UniqueBookings/uniqueBookingsSlice";
import { graphUniqueBought, setUniqueBought, SelectBoughtVisitors } from "../../Main/components/UniqueBought/uniqueBoughtSlice";

const SalesSummary = () => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser.split("@")[0];

  const uniqueBnDevData = useSelector(SelectUniqueBrowsers);
  const bookingsVisitorsData = useSelector(SelectBookingsVisitors);
  const boughtVisitorsData = useSelector(SelectBoughtVisitors);
  const UniqueBookingsData = useSelector((state) => state.uniqueBookings);

  const [siteVisitorsObj, setSiteVisitorsObj] = useState({ loading: true });
  const [addToCartObj, setAddToCartObj] = useState({ loading: true });
  const [overallSalesObj, setOverallSalesObj] = useState({ loading: true });

  const find_trend_perc = (curr, prev) => {
    const trend = curr > prev ? "incr" : "decr";
    const trend_perc = prev !== 0 ? ((Math.abs(curr - prev) * 100) / prev).toFixed(2) : 0;
    return [trend, trend_perc];
  };

  const updateState = (data, stateSetter, name, image) => {
    if (data.length) {
      const size = data.length;
      const [trend, trend_perc] = find_trend_perc(data[size - 1], data[size - 2]);
      stateSetter({
        name,
        value: data[size - 1],
        percent: trend_perc,
        trend,
        image,
        loading: false, 
      });
    } else {
      user && dispatch(data === uniqueBnDevData ? graphUniqueBnDev(user) : data === bookingsVisitorsData ? graphUniqueBookings(user) : graphUniqueBought(user));
    }
  };

  useEffect(() => {
    updateState(uniqueBnDevData, setSiteVisitorsObj, "Site visitors", visitorImage);
  }, [user, uniqueBnDevData]);

  useEffect(() => {
    updateState(bookingsVisitorsData, setAddToCartObj, "Add to Cart", cartImage);
  }, [user, bookingsVisitorsData]);

  useEffect(() => {
    updateState(boughtVisitorsData, setOverallSalesObj, "Overall Sales", dollarImage);
  }, [user, boughtVisitorsData]);

  useEffect(() => {
    UniqueBookingsData.weeks?.length > 0 && dispatch(setUniqueBought(UniqueBookingsData?.data));
  }, [UniqueBookingsData]);

  return (
    <div>
      <h5 className="p-2 fs-5 fw-bold mb-1">Sales Summary</h5>
      <div className="flex flex-wrap">
        <CohortCard data={overallSalesObj} />
        <CohortCard data={addToCartObj} />
        <CohortCard data={siteVisitorsObj} />
      </div>
    </div>
  );
};

export default SalesSummary;
